import styled from 'styled-components';

import indexBuriedPoint from '@/utils/_indexBuriedPoint';
import Utils from '@/utils/Utils';

const Content = styled.section`
  background-color: transparent;
  &.hasAll {
    width: 501px;
    height: 726px;
    padding-top: 82px;
    background-image: url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-n.png),
      url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-light.png);
    background-position:
      0 0,
      -10px -40px;
    background-size:
      auto,
      550px auto;
    background-repeat: no-repeat;
  }
  &.onlyCoupons {
    width: 501px;
    height: 428px;
    padding-top: 82px;
    background-image: url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-3.png),
      url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-light.png);
    background-position:
      0 0,
      -10px -40px;
    background-size:
      auto,
      550px auto;
    background-repeat: no-repeat;
  }
  &.notHaveProduct {
    width: 501px;
    height: 508px;
    padding-top: 82px;
    background-image: url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-2.png),
      url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-light.png);
    background-position:
      0 0,
      -10px -40px;
    background-size:
      auto,
      550px auto;
    background-repeat: no-repeat;
  }
  &.notHaveTask {
    width: 501px;
    height: 641px;
    padding-top: 82px;
    background-image: url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-4-n.png),
      url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/bg-light.png);
    background-position:
      0 0,
      -10px -40px;
    background-size:
      auto,
      550px auto;
    background-repeat: no-repeat;
  }
`;

// 商品券 couponType = product
// 运费券 couponType = freight
// MRO运费券 couponType = mro_freight
// 折扣券 couponType = discount
// PLUS会费券 couponType = plus
// 包邮券 freeExpress = true
// 面板打印券 isDosCoupon = true

const couponTypeMap = {
  product: '商品券',
  freight: '运费券',
  discount: '折扣券',
  mro_freight: 'MRO运费券',
  plus: 'PLUS会费券',
};

function handleClick(targetLink) {
  indexBuriedPoint('Newcomer_benefits', targetLink, 'click', 'open');
}

const CouponsArea = ({ data, targetLink }) => {
  return (
    <ul className="flex items-center">
      {data.map((coupon, idx) => {
        let couponTypeName = couponTypeMap[coupon.couponType];
        if (coupon.isDosCoupon) {
          couponTypeName = '面板打印券';
        } else if (coupon.freeExpress) {
          couponTypeName = '包邮券';
        }
        // 满减券
        let couponAmountContent = (
          <>
            {/* 面额保留一位小数且向下取整 */}
            <span className="text-[32px]">{Math.floor(coupon.couponAmount * 10) / 10}</span> 元
          </>
        );
        // 包邮券
        if (coupon.isFreeExpress) {
          couponAmountContent = <span className="text-[30px]">包邮</span>;
        }
        // 折扣券
        if (coupon.couponType === 'discount') {
          couponAmountContent = (
            <>
              {/* 保留一位小数且向下取整 */}
              <span className="text-[32px]">{Math.floor(coupon.couponDiscount * 10) / 10}</span> 折
            </>
          );
        }
        return (
          <a key={idx} href={targetLink} target="_blank" onClick={() => handleClick(targetLink)}>
            <li
              className={`relative size-[100px] pt-[29px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/coupon-bg.svg)] ${idx === 3 ? 'mr-0' : 'mr-[8px]'}`}
            >
              <span className="absolute top-0 left-0 h-[24px] leading-[24px] text-[#333] pl-[7px] pr-[9px] bg-[#FFEEC9] rounded-tl-[10px] rounded-br-[8px]">
                有效期{coupon.couponValidDay}天
              </span>
              <span className="text-center block h-[43px] leading-[43px] text-[14px] text-[#F43421]">
                {couponAmountContent}
              </span>
              <span className="text-center block leading-[19px] text-[14px] text-[#F43421]">
                <span> {couponTypeName}</span>
              </span>
            </li>
          </a>
        );
      })}
    </ul>
  );
};

const ProductsArea = ({ data, targetLink }) => {
  return (
    <ul className="flex items-center text-[#F43421]">
      {data.map((product, idx) => (
        <a key={idx} href={targetLink + '#items'} target="_blank" onClick={() => handleClick(targetLink)}>
          <li
            className={`px-[8px] w-[97px] h-[117px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/item-bg.svg)] ${idx === 3 ? 'mr-0' : 'mr-[12px]'}`}
          >
            <img
              className="size-[69px] mx-auto"
              src={
                product.productImage || 'https://static.szlcsc.com/ecp/assets/web/common/images/productItem/mouser.jpg'
              }
              alt={product.productName}
            />
            <span className="block font-bold text-[14px] mt-[5px] truncate">{product.productName}</span>
            <span className="block text-[#00000099] h-[21px] leading-[16px]">
              <span className="text-[12px]">原价</span>￥
              <span className="text-[12px]">{Number(product?.productLadderPrice)?.toFixed(2)}</span>
            </span>
          </li>
        </a>
      ))}
    </ul>
  );
};
const EnterpriseCertificationTaskArea = ({ data }) => {
  return (
    <p className="text-[14px] text-white leading-[19px] truncate">
      还能获得
      {data.map((coupon, idx) => (
        <span key={idx}>
          {coupon.couponName}
          {idx === data.length - 1 ? '' : '、'}
        </span>
      ))}
    </p>
  );
};

const NewCustomerPop = ({ data, targetLink }) => {
  if (data) {
    const couponsWrapClassName = 'mt-[25px] w-[442px] h-[145px] pt-[40px] px-[9px] pb-[8px] mx-auto';
    const productssWrapClassName = 'mt-[10px] w-[442px] h-[200px] pt-[40px] px-[9px] pb-[8px] mx-auto';
    const enterpriseCertificationTaskWrapClassName = 'mt-[16px] w-[442px] h-[67px] mx-auto pt-[35px] text-center';

    let contentClassName = 'hasAll'; // 三块内容都有（新人券，新人特价商品，认证企业叠加券包）
    if (Utils.isEmpty(data.hotProducts) && data.enterpriseCertificationTask) {
      contentClassName = 'notHaveProduct'; // 没有新人特价商品
    }
    if (Utils.isEmpty(data.hotProducts) && !data.enterpriseCertificationTask) {
      contentClassName = 'onlyCoupons'; // 只有新人券包
    }
    if (data.hotProducts && !data.enterpriseCertificationTask) {
      contentClassName = 'notHaveTask'; // 没有认证企业叠加券包
    }
    return (
      <Content className={contentClassName}>
        <section className="main-area pt-[35px]">
          <h2 className="text-[28px] font-bold leading-[37px] tracking-[1px] text-center">
            恭喜您获得<span className="text-[#F43421]">新人专享福利</span>
          </h2>
          {data?.coupons?.length > 0 && (
            <section className={couponsWrapClassName}>
              <CouponsArea data={data.coupons.slice(0, 4)} targetLink={targetLink} />
            </section>
          )}
          {data?.hotProducts?.length > 0 && (
            <section className={productssWrapClassName}>
              <ProductsArea data={data.hotProducts.slice(0, 4)} targetLink={targetLink} />
              <p className="mt-[8px] font-bold text-[14px] text-[#fff] text-center">
                爆款好物 低至<span className="text-[18px] text-[#FFE958]">1元</span>起
              </p>
            </section>
          )}
          {data?.enterpriseCertificationTask?.couponList?.length > 0 && (
            <section className={enterpriseCertificationTaskWrapClassName}>
              <EnterpriseCertificationTaskArea data={data?.enterpriseCertificationTask.couponList.slice(0, 3)} />
            </section>
          )}
          <a
            href={targetLink}
            target="_blank"
            className="bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/modal/newCustomer/receive-btn.svg)] block mt-[17px] w-[214px] h-[70px] mx-auto rounded-[35px] leading-[70px] text-[20px] text-white font-bold tracking-[1px] hover:opacity-80 hover:text-white text-center"
            onClick={() => handleClick(targetLink)}
          >
            查看全部福利
          </a>
        </section>
      </Content>
    );
  }
};

export default NewCustomerPop;
